import React, { useRef } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getSrc } from 'gatsby-plugin-image';
import cn from 'classnames';
import style from './hero.mod.scss';
import Logo from '../global/icons/logo';
import Container from '../layout/container/container';
import '@mux/mux-player';

const Hero = () => {
  const classes = cn(style.hero);
  const videoRef = useRef(null);

  const data = useStaticQuery(graphql`
    query {
      datoCmsHome {
        heroVideo {
          video {
            streamingUrl
            mp4Url
            thumbnailUrl
            muxPlaybackId
          }
        }
        heroVideoPoster {
          gatsbyImageData(imgixParams: {ar: "16:9"})
        }
      }
    }
  `);

  const muxPlaybackId = data.datoCmsHome.heroVideo.video.muxPlaybackId;
  const heroVideoPoster = getSrc(data.datoCmsHome.heroVideoPoster);


  return (
    <Container bg="white">
      <div className={classes}>
        <div className={style.hero__main}>
          <mux-player
            ref={videoRef}
            stream-type="on-demand"
            playback-id={muxPlaybackId}
            autoplay
            muted
            loop
            no-controls
            poster={heroVideoPoster}
            className={style.hero__video}
          />
        </div>
        <div className={style.hero__heading}>
          <Logo />
          <h1>We Create Fun</h1>
        </div>
      </div>
    </Container>
  );
};

export default Hero;
